import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { readStoredTrainingId } from '../core/training-id-storage';

@Injectable({ providedIn: 'root' })
export class TrainingIdGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return readStoredTrainingId() ? true : this.router.parseUrl('/');
  }
}
